import AppNexus from '@components/AppNexus'
import { isNotNativeOnlyAd } from '@utils/ads'
import { FunctionComponent } from 'react'
import { CookWidget } from '@widgets/types'

export interface AppNexusWidgetProps {
  kind: string[]
  slotCode?: string
  slotCodeMobile?: string
  placement: string
}

const AppNexusWidget: FunctionComponent<AppNexusWidgetProps> = (props) => {
  const { kind, ...restOfProps } = props

  if (!isNotNativeOnlyAd(props)) {
    return null
  }

  return <AppNexus {...restOfProps} />
}

const widget: CookWidget = {
  kind: ['widget', 'ad', 'appnexus'],
  component: AppNexusWidget,
}

export default widget
